import { Button } from "@core/button";
import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Text } from "@core/index";

const ErrorComponent = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 dark:from-gray-900 dark:to-blue-900">
      <div className="container max-w-7xl mx-auto px-4 py-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-lg rounded-2xl shadow-xl p-8 border border-gray-200/50 dark:border-gray-700/50">
            <div className="flex flex-col items-center justify-center space-y-4">
              <div className="p-4 rounded-full bg-red-100 dark:bg-red-900/50">
                <AlertTriangle
                  size={32}
                  className="text-red-600 dark:text-red-400"
                />
              </div>
              <Text variant={"h2"} className="!text-red-600 dark:!text-red-400">
                {title}
              </Text>
              <Text
                variant={"p"}
                status="subtle"
                className="text-center max-w-md"
              >
                {description}
              </Text>
              <Button
                variant="solid"
                size="md"
                rounded="lg"
                bgColor="bg-red-100 hover:bg-red-200 dark:bg-red-900/50 dark:hover:bg-red-900/70"
                textColor="text-red-600 dark:text-red-400"
                onClick={() => window.location.reload()}
              >
                {t("hooks.result.error.retryButton")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorComponent;
